
import { Component } from '@angular/core';

@Component({
  selector: 'fill-in.page',
  template: '<router-outlet></router-outlet>'
})
export class FillInComponent { }
